<template>
  <div class="TitleScreen">
    <div class="outer-content">

      <div class="niwa-logo"></div>

      <div class="inner-content no-click">

        <div class="title-large"></div>

        <DialogueBox v-if="playGame && introDismissed == false" :width="688" :height="336" :top="366" :left="296">
          <div class="intro-inner yes-click">
            <div v-html="T('HomeScreen_Intro')"></div>
            <div @click="$emit('dismiss-intro', true)" v-html="T('button_play_game')" class="play-button btn-base"></div>
          </div>
        </DialogueBox>

        <template v-if="introDismissed">
          <div class="facilitator"></div>
          <div class="intro-speech-bubble">
            <div class="intro-title" v-html="T('Tui_title_Intro_1')"></div>
            <div class="intro-text" v-html="T('Tui_title_Intro_2')"></div>
            <div class="button-container">
              <div @click="$emit('dismiss-intro', false)" v-html="T('button_back')"
                class="back-button btn-base yes-click">
              </div>
              <div @click=" $emit('play-game')" v-html="T('button_continue')" class="play-button btn-base yes-click">
              </div>
            </div>
          </div>
        </template>


        <!--
          <div class="top-copy" v-html="T('HomeScreen_Intro')"></div>

          <div class="tui">
          </div>

          <div id="wrapper" v-if="playGame">
            <div id="speech_bubble">
              <img src="/Images/intro-speech-bubble@3x.svg">
              <div class="extend_bubble"></div>
              <template v-if="playGame">
                <div @click="$emit('how-to-play')" v-html="T('button_how_to_play')" class="how-to-play btn-base"></div>
              </template>
  <div id="text_speech">
    <h2 class="speech_title" v-html="T('Tui_title_Intro_1')"></h2>
    <p class="speech_body" v-html="T('Tui_title_Intro_2')"></p>
  </div>
  </div>
  </div>
  -->

      </div>

      <div class="footer-bar" v-if="playGame && introDismissed == false">
        <div class="footer-bar-left">
          <a target="_blank" :href="T('Terms_Of_Use_Link')" v-html="T('Terms_Of_Use')"></a>
          |
          <a target="_blank" :href="T('Privacy_Policy_Link')" v-html="T('Privacy_Policy')"></a>
        </div>
        <div class="footer-bar-right">
          <div v-html="T('Designed_By_Hum_1')"></div>
          <div v-html="T('Designed_By_Hum_2')"></div>
        </div>
      </div>

    </div>
  </div>
</template>

<script lang="ts">
import { T } from '@/App.vue';
import DialogueBox from '@/components/DialogueBox.vue';
import Vue from 'vue';

export default Vue.extend({
  name: 'TitleScreen',
  props: {
    playGame: Boolean,
    introDismissed: Boolean,
  },
  components: {
    DialogueBox,
  },
  methods: {
    T(key: string): string {
      return T(key);
    }
  }
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
.footer-bar a {
  color: white;
  text-decoration: underline;
}
</style>

<style scoped lang="less">
.footer-bar-right {
  text-align: right;
}

.footer-bar {
  position: absolute;
  width: 100%;
  background-color: #292E44;
  height: 80px;
  bottom: 0px;
  font-family: Rubik;
  font-size: 14px;
  font-weight: 400;
  line-height: 16.59px;
  letter-spacing: 0.011666666716337204px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  color: white;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding-left: 24px;
  padding-right: 24px;
}

.title-large {
  width: 483px;
  height: 100px;
  top: 40px;
  left: 290px;
  position: absolute;
  background-image: url("../assets-fca/UI/title_large.svg");
}

.niwa-logo {
  width: 181px;
  height: 66px;
  top: 33px;
  left: 35px;
  position: absolute;
  background-image: url("../assets-fca/UI/niwa_logo.svg");
}

.intro-inner {
  position: absolute;
  width: 576px;
  height: 100%;
  left: 56px;
  top: 35px;

  font-family: Rubik;
  font-size: 16px;
  font-weight: 400;
  line-height: 18.96px;
  letter-spacing: -0.17599999904632568px;
  text-align: center;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;

  display: flex;
  flex-direction: column;
  align-items: center;
}

.play-button {
  background-color: #B2CD30;
  width: 162px;
  height: 50px;
  border-radius: 8px;
  margin-top: 16px;
  color: #fff;
  font-family: Rubik;
  font-size: 14px;
  font-weight: 800;
  line-height: 16.59px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
}

.back-button {
  .play-button;
  background-color: #F1A738;
}

.facilitator {
  position: absolute;
  width: 384.13px;
  height: 489.54px;
  top: 385.85px;
  left: -38.17px;
  background-size: cover;
}

.intro-speech-bubble {
  width: 512px;
  height: 284px;
  top: 400px;
  left: 251px;
  position: absolute;
  background-size: cover;
  background-image: url("../assets-fca/Speech Bubbles/intro-speech-bubble.svg");
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 26px;
  padding-left: 107px;
  padding-right: 60px;
  font-family: Rubik;
  font-size: 18px;
  font-weight: 400;
  line-height: 21.33px;
  letter-spacing: -0.1979999989271164px;
  text-align: center;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  color: #685A54;
}

.intro-title {
  font-family: Rubik;
  font-size: 29.12px;
  font-weight: 800;
  line-height: 34.51px;
  letter-spacing: -0.0582394003868103px;
  text-align: center;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  color: #636252;
}

.intro-text {
  margin-top: 16px;
  margin-bottom: 8px;
}

.button-container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
}
</style>